module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "push-setup"
  }, [(!_vm.isSupported) ? _c('div', {
    staticClass: "push-message"
  }, [_c('p', [_vm._v("Push notifications are not supported in this browser.")])]) : (!_vm.isConfigured) ? _c('div', {
    staticClass: "push-message"
  }, [_c('p', [_vm._v("Push notifications are not available right now. Please check back later.")])]) : (_vm.needsIOSInstall) ? _c('div', [_c('p', {
    staticClass: "push-message"
  }, [_vm._v("To receive push notifications on iOS, you need to install this app to your home screen first.")]), _vm._v(" "), _c('button', {
    staticClass: "button-push",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showIOSGuide = true
      }
    }
  }, [_vm._v("How to Install")]), _vm._v(" "), (_vm.showIOSGuide) ? _c('ios-install-guide', {
    on: {
      "close": function($event) {
        _vm.showIOSGuide = false
      }
    }
  }) : _vm._e()], 1) : (_vm.permissionState === 'denied') ? _c('div', {
    staticClass: "push-message"
  }, [_c('p', [_vm._v("Push notifications are blocked. To enable them, open your browser settings and allow notifications for this site.")])]) : _c('div', [(_vm.canInstallAndroid) ? _c('div', {
    staticClass: "install-section"
  }, [_c('button', {
    staticClass: "button-push",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.installAndroid()
      }
    }
  }, [_vm._v("Install App")]), _vm._v(" "), _c('p', {
    staticClass: "help-text"
  }, [_vm._v("For the best experience")])]) : _vm._e(), _vm._v(" "), (_vm.justBecameStandalone && !_vm.isSubscribed) ? _c('div', {
    staticClass: "success-message"
  }, [_vm._v("\n      App installed successfully! Now enable push notifications below.\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.isSubscribed) ? _c('div', [_c('button', {
    staticClass: "button-push",
    attrs: {
      "type": "button",
      "disabled": _vm.subscribing
    },
    on: {
      "click": function($event) {
        _vm.subscribe()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.subscribing ? 'Enabling...' : 'Enable Push Notifications') + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.isSubscribed) ? _c('div', {
    staticClass: "success-message"
  }, [_vm._v("\n      Push notifications enabled on this device.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.devices.length > 0) ? _c('div', {
    staticClass: "device-section"
  }, [_c('p', {
    staticClass: "device-header"
  }, [_vm._v("Registered devices (" + _vm._s(_vm.devices.length) + "):")]), _vm._v(" "), _c('ul', {
    staticClass: "device-list"
  }, _vm._l((_vm.devices), function(device, index) {
    return _c('li', {
      key: device.id
    }, [_c('span', {
      staticClass: "device-name"
    }, [_vm._v(_vm._s(_vm.deviceLabel(device)))]), _vm._v(" "), _c('button', {
      staticClass: "button-remove",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeDevice(device)
        }
      }
    }, [_vm._v("Remove")])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d31545d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PushSetup.vue
// module id = 307
// module chunks = 1